import type { Issue } from "contracts/api/issue/responses";
import type { IssueSemanticFact } from "contracts/api/issue/semantics";
import { ISSUE_SEMANTIC_FACT_KIND } from "contracts/enums/issue-semantics";

type HeadingFact = Extract<
  IssueSemanticFact,
  { kind: typeof ISSUE_SEMANTIC_FACT_KIND.HEADING }
>;
type WordingFact = Extract<
  IssueSemanticFact,
  { kind: typeof ISSUE_SEMANTIC_FACT_KIND.WORDING }
>;
type JourneyFact = Extract<
  IssueSemanticFact,
  { kind: typeof ISSUE_SEMANTIC_FACT_KIND.JOURNEY }
>;
type OriginConditionFact = Extract<
  IssueSemanticFact,
  { kind: typeof ISSUE_SEMANTIC_FACT_KIND.ORIGIN_CONDITION }
>;
type ArchitectureFact = Extract<
  IssueSemanticFact,
  { kind: typeof ISSUE_SEMANTIC_FACT_KIND.ARCHITECTURE }
>;

function semanticFacts(issue: Issue): IssueSemanticFact[] {
  return [...issue.semanticProfile.facts];
}

export function headingFact(issue: Issue): HeadingFact | null {
  return (
    semanticFacts(issue).find(
      (fact): fact is HeadingFact =>
        fact.kind === ISSUE_SEMANTIC_FACT_KIND.HEADING,
    ) ?? null
  );
}

export function wordingFact(issue: Issue): WordingFact | null {
  return (
    semanticFacts(issue).find(
      (fact): fact is WordingFact =>
        fact.kind === ISSUE_SEMANTIC_FACT_KIND.WORDING,
    ) ?? null
  );
}

export function journeyFact(issue: Issue): JourneyFact | null {
  return (
    semanticFacts(issue).find(
      (fact): fact is JourneyFact =>
        fact.kind === ISSUE_SEMANTIC_FACT_KIND.JOURNEY,
    ) ?? null
  );
}

export function originConditionFact(issue: Issue): OriginConditionFact | null {
  return (
    semanticFacts(issue).find(
      (fact): fact is OriginConditionFact =>
        fact.kind === ISSUE_SEMANTIC_FACT_KIND.ORIGIN_CONDITION,
    ) ?? null
  );
}

export function architectureFact(issue: Issue): ArchitectureFact | null {
  return (
    semanticFacts(issue).find(
      (fact): fact is ArchitectureFact =>
        fact.kind === ISSUE_SEMANTIC_FACT_KIND.ARCHITECTURE,
    ) ?? null
  );
}
